Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var require_logger = require('./logger.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
//#region src/utils/tool.ts
function addUniqueItem(arr, item) {
    if (arr.findIndex((name)=>name === item) === -1) arr.push(item);
    return arr;
}
function getFMId(remoteInfo) {
    if ("version" in remoteInfo && remoteInfo.version) return `${remoteInfo.name}:${remoteInfo.version}`;
    else if ("entry" in remoteInfo && remoteInfo.entry) return `${remoteInfo.name}:${remoteInfo.entry}`;
    else return `${remoteInfo.name}`;
}
function isRemoteInfoWithEntry(remote) {
    return typeof remote.entry !== "undefined";
}
function isPureRemoteEntry(remote) {
    return !remote.entry.includes(".json");
}
function safeWrapper(callback, disableWarn) {
    return _async_to_generator._(function*() {
        try {
            return yield callback();
        } catch (e) {
            !disableWarn && require_logger.warn(e);
            return;
        }
    })();
}
function isObject(val) {
    return val && typeof val === "object";
}
var objectToString = Object.prototype.toString;
function isPlainObject(val) {
    return objectToString.call(val) === "[object Object]";
}
function isStaticResourcesEqual(url1, url2) {
    var REG_EXP = /^(https?:)?\/\//i;
    return url1.replace(REG_EXP, "").replace(/\/$/, "") === url2.replace(REG_EXP, "").replace(/\/$/, "");
}
function arrayOptions(options) {
    return Array.isArray(options) ? options : [
        options
    ];
}
function getRemoteEntryInfoFromSnapshot(snapshot) {
    var defaultRemoteEntryInfo = {
        url: "",
        type: "global",
        globalName: ""
    };
    if (_module_federation_sdk.isBrowserEnvValue || (0, _module_federation_sdk.isReactNativeEnv)() || !("ssrRemoteEntry" in snapshot)) return "remoteEntry" in snapshot ? {
        url: snapshot.remoteEntry,
        type: snapshot.remoteEntryType,
        globalName: snapshot.globalName
    } : defaultRemoteEntryInfo;
    if ("ssrRemoteEntry" in snapshot) return {
        url: snapshot.ssrRemoteEntry || defaultRemoteEntryInfo.url,
        type: snapshot.ssrRemoteEntryType || defaultRemoteEntryInfo.type,
        globalName: snapshot.globalName
    };
    return defaultRemoteEntryInfo;
}
var processModuleAlias = (name, subPath)=>{
    var moduleName;
    if (name.endsWith("/")) moduleName = name.slice(0, -1);
    else moduleName = name;
    if (subPath.startsWith(".")) subPath = subPath.slice(1);
    moduleName = moduleName + subPath;
    return moduleName;
};
//#endregion
exports.addUniqueItem = addUniqueItem;
exports.arrayOptions = arrayOptions;
exports.getFMId = getFMId;
exports.getRemoteEntryInfoFromSnapshot = getRemoteEntryInfoFromSnapshot;
exports.isObject = isObject;
exports.isPlainObject = isPlainObject;
exports.isPureRemoteEntry = isPureRemoteEntry;
exports.isRemoteInfoWithEntry = isRemoteInfoWithEntry;
exports.isStaticResourcesEqual = isStaticResourcesEqual;
exports.objectToString = objectToString;
exports.processModuleAlias = processModuleAlias;
exports.safeWrapper = safeWrapper; //# sourceMappingURL=tool.cjs.map
